import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { constant } from 'app/app.constants';
import { LiveTripResponse } from 'app/core/interfaces/live-trip.interface';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {map} from 'rxjs/operators';
import { SignalRService } from 'app/core/services/signal-r.service';

@Injectable()
export class LiveTripService {
  private tripId: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public tripId$ = this.tripId.asObservable();

  private tripData: BehaviorSubject<LiveTripResponse> =
    new BehaviorSubject<LiveTripResponse>(null);
  public tripData$ = this.tripData.asObservable();

  private reloadTripData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public reloadTripData$ = this.reloadTripData.asObservable();

  private _connection = new BehaviorSubject<any>(null);
  private tripsHubConnection = 'LiveTrip';

  constructor(private http: Http, private signalRService: SignalRService) {}

  public getLiveTripData(tripId: string): Observable<LiveTripResponse> {
    return this.http
      .get(`${constant.URL_LIVE_TRIP}/${tripId}`)
      .pipe(map((response: any) => response.json() as LiveTripResponse))
      .catch((error: any) => Observable.throw(error.json()));
  }

  public setTripId(tripId: string) {
    this.tripId.next(tripId);
  }

  public setTripData(data: LiveTripResponse) {
    this.tripData.next(data);
  }

  public setReloadTripData(reload: boolean) {
    this.reloadTripData.next(reload);
  }

  public closeSignalR(url: string, driverId: number): void {
    const connection = this._connection.getValue();
    if (connection) {
      this.signalRService
        .deleteHubConnection(url, driverId)
        .toPromise();
      this.signalRService.unsubscribeTo(this.tripsHubConnection);
      this.signalRService.stop();
      this.setConnection(null);
    }
  }

  public setConnection(connection: any): void {
    this._connection.next(connection);
  }
}



// WEBPACK FOOTER //
// ./src/app/public/services/live-trip.service.ts